import { apiFetch } from '../../lib/api/client.js';
import type { BannerItem } from './select.js';

export const BANNER_QUERY_KEYS = {
  active: ['banners', 'active'] as const,
};

/**
 * Banners inside their display window for the viewer's own brand. Guest-safe:
 * the gateway stamps x-agent-id from the host even without a token, and
 * svc-notify falls back to it when no operator scope is present.
 *
 * The auth-state filter is deliberately NOT a query parameter. Whether the
 * visitor is signed in is a client fact, and this read is anonymous — asking
 * the caller to declare it would be asking it to choose its own audience.
 */
export async function fetchActiveBanners(): Promise<BannerItem[]> {
  const res = await apiFetch<{ items: BannerItem[] }>('/banners?active=true&pageSize=20');
  return res.items ?? [];
}
